var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"clock-in"},[_c('el-button',{class:['clock-in-btn', `btn-status-${_vm.seatClockStatus}`, {['btn-timeOut']: _vm.timeOut}],attrs:{"type":_vm.seatClockStatus,"size":"small","disabled":_vm.timeOut && _vm.seatClockStatus !== 'success'},on:{"click":_vm.clockIn}},[_vm._v(_vm._s(_vm.clockInProgressCn))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }